import { getTextField } from '@lender/utils';
import { array, object } from 'yup';

// Specific-year requiredness is derived from live form state and the schema rebuilt on change,
// not a yup `.when('yearMode', …)`: `yearMode` is a getTextField() string schema, so yup casts
// the selected `{ value }` option to "[object Object]" before the `is` predicate runs, leaving
// `yearMode?.value` undefined and the Specific branch permanently dead.
export const getHalcyonAddFormsSchema = ({ isSpecificYears }) =>
  object().shape({
    forms: array().min(1, 'At least one form is required').required('Forms can not be empty'),
    yearMode: getTextField(),
    specificYears: isSpecificYears
      ? array().min(1, 'At least one year is required').required('Specific Years can not be empty')
      : array().notRequired(),
  });
